import { pushCtaBlockAction } from "./datalayer"
import { Block } from "./library/container"
import { Link } from "./library/link"
import React = require("react")
import { slugify } from "../../../Shared/utils/string"

export interface CtaBlockProps {
  readonly kind: "cta_block" | "cta_activity_block"
  readonly title: string
  readonly description: string
  readonly primaryActionTitle: string
  readonly primaryActionUrl: string
  readonly secondaryActionTitle: string
  readonly secondaryActionUrl: string
}

const renderDescription = (contents: string | JSX.Element, htmlElement: JSX.Element, jsxElement: JSX.Element) => {
  return typeof contents == "string" ? (
    <htmlElement.type
      {...htmlElement.props}
      key={htmlElement.key}
      dangerouslySetInnerHTML={{ __html: contents }}
    />
  ) : (
    <jsxElement.type
      key={jsxElement.key}
      {...jsxElement.props}
    >
      {contents}
    </jsxElement.type>
  )
}

export class CtaBlock extends React.Component<CtaBlockProps, {}> {
  render() {
    const p = this.props

    return (
      <Block>
        <section className={`cta cta--block ${p.kind == 'cta_block' ? 'cta--large' : 'cta--small'}`}>
          <header className="cta__header">
            <h2 data-anchor={slugify(p.title)} className={`cta__title ${p.kind == 'cta_block' ? 'title--l' : 'title--ms'}`}>{p.title}</h2>
          </header>

          <div className="cta__content">
            {renderDescription(p.description, <div className="cta__text" />, <div />)}
          </div>

          <footer className="cta__footer">
            <Link url={p.primaryActionUrl} className="cta__button button button--primary button--arrow" handle={() => pushCtaBlockAction(p.title, "primary", p.primaryActionTitle)}>
              {p.primaryActionTitle}
            </Link>

            {p.secondaryActionTitle && p.secondaryActionUrl &&
              <Link url={p.secondaryActionUrl} className="cta__link button button--secondary button--arrow" handle={() => pushCtaBlockAction(p.title, "secondary", p.secondaryActionTitle)}>
                <svg className="cta__link-icon" width="8px" height="14px" aria-hidden="true"><use xlinkHref="#icon--chevron-right"></use></svg>
                <span>{p.secondaryActionTitle}</span>
              </Link>}
          </footer>
        </section>
      </Block>
    )
  }
}
